import styled from "styled-components";

export const ResetPassword = styled.div`
  min-height: 100svh;
`

export const ResetPasswordImageWrapper = styled.div`
  position: absolute;
  width: 50%;
  min-height: 100svh;
  right: 0;
  top: 0;
  display: none;

  ${({ theme }) => theme.mediaQuery.lg(`
    display: block;
  `)}

  img {
    object-fit: cover;
    object-position: center;
  }
`

export const ResetPasswordForm = styled.div`
  padding: ${({ theme }) => theme.rem(32)};

  ${({ theme }) => theme.mediaQuery.md(`
    padding: ${theme.rem(64)};
  `)}
`

export const ResetPasswordFormRegister = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.rem(8)};
  align-items: center;
`

export const ResetPasswordFormRegisterCTA = styled.div`
  text-decoration: underline;
  cursor: pointer;
`

export const ResetPasswordFormResetPassword = styled.div`
  text-align: center;
`

export const ResetPasswordFormInputWrapper = styled.div``

export const ResetPasswordFormIcon = styled.div`
  i {
    font-size: ${({ theme }) => theme.rem(24)};
  }
`

export const ResetPasswordFormLogoWrapper = styled.div``

